<svg
  [attr.width]="width()"
  [attr.height]="height()"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.70013 11.817C6.60013 11.817 6.50569 11.8003 6.4168 11.767C6.32791 11.7337 6.24457 11.6781 6.1668 11.6003L3.30013 8.73366C3.15569 8.58921 3.08635 8.40855 3.09213 8.19166C3.09746 7.97521 3.17235 7.79477 3.3168 7.65033C3.46124 7.50588 3.64191 7.43366 3.8588 7.43366C4.07524 7.43366 4.25013 7.50588 4.38346 7.65033L6.70013 9.96699L12.2835 4.38366C12.4168 4.23921 12.5946 4.16699 12.8168 4.16699C13.039 4.16699 13.2224 4.23921 13.3668 4.38366C13.5001 4.5281 13.5668 4.70855 13.5668 4.92499C13.5668 5.14188 13.5001 5.32255 13.3668 5.46699L7.23346 11.6003C7.15569 11.6781 7.07235 11.7337 6.98346 11.767C6.89458 11.8003 6.80013 11.817 6.70013 11.817Z"
    [attr.fill]="color()"
  />
</svg>
